module.exports = __webpack_public_path__ + "static/media/subjectCreditRecordPersonTemp.6f3e4fc2.xlsx";